@import '../../styles/_vars.css';

.section {
    background-image: url('../../assets/ccc-age-gate-bg.webp');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    color: var(--color-text);
    width: 100%;
    min-height: 100vh;
    overflow-y: auto;
    font-size: 14px;
    display: flex;
    align-items: center;
}

@media (min-width: 1024px) {
    .section {
     font-size: 18px;
    }
}

.ageGateLogo {
    width: 50%;
    margin: 0 auto;
}

.container {
    background-color: white;
    display: flex;
    flex-direction: column;
    max-width: 50em;
    margin-left: auto;
    margin-right: auto;
    padding-top: 2em;
    height: 100%;
    font-size: 1em;
    overflow-y: auto;
    /* Hide scrollbar */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    padding-left: 1.5em;
    padding-right: 1.5em;
}

.container::-webkit-scrollbar {
    display: none; /* WebKit browsers */
}

@media (min-width: 1024px) {
    .container {
        font-size: inherit;
        padding-left: 5em;
        padding-right: 5em;
        padding-top: 4em;
    }
}

.heading {
    font-size: 1.125em;
    font-weight: 500;
    margin-top: 2.5em;
    margin-bottom: 1.25em;
}

.locationWrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5em;
    margin-bottom: 2.5em;
}

.paragraph {
    font-weight: 500;
    margin-top: 1em;
    margin-bottom: 5em;
    opacity: 0.8;
    font-size: 0.875em;
    line-height: 1.25em;
}

.buttonWrapper {
    display: flex;
    justify-content: center;
    margin-top: .5em;
}

.checkboxWrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: 0.5em;
    margin-bottom: 1em;
}

.checkboxBox {
    width: 16px;
    height: 16px;
    border: 2px solid var(--color-btn-second);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 4px;
}

.checkboxInnerCheck {
    width: 8px;
    height: 8px;
    background-color: var(--color-text);
    border-radius: 2px;
    display: block;
}

.checkboxLabel {
    font-size: 1.125em;
    font-weight: 500;
}

.ButtonWrapper button {
    width: 250px;
}

